import { FrenchDepartment } from './french-department.enum';

export enum FrenchRegion {
  AUVERGNE_RHONE_ALPES = '84',
  BOURGOGNE_FRANCHE_COMTE = '27',
  BRETAGNE = '53',
  CENTRE_VAL_DE_LOIRE = '24',
  CORSE = '94',
  GRAND_EST = '44',
  HAUTS_DE_FRANCE = '32',
  ILE_DE_FRANCE = '11',
  NORMANDIE = '28',
  NOUVELLE_AQUITAINE = '75',
  OCCITANIE = '76',
  PAYS_DE_LA_LOIRE = '52',
  PROVENCE_ALPES_COTE_D_AZUR = '93',
  GUADELOUPE = '01',
  MARTINIQUE = '02',
  GUYANE = '03',
  LA_REUNION = '04',
  MAYOTTE = '06',
}

export interface FrenchDepartmentInfo {
  code: string;
  name: string;
  department: FrenchDepartment;
  region: FrenchRegion;
}

export interface FrenchRegionInfo {
  code: FrenchRegion;
  name: string;
  departments: FrenchDepartment[];
}

export const FRENCH_REGIONS: FrenchRegionInfo[] = [
  {
    code: FrenchRegion.AUVERGNE_RHONE_ALPES,
    name: 'Auvergne-Rhône-Alpes',
    departments: [
      FrenchDepartment.AIN,
      FrenchDepartment.ALLIER,
      FrenchDepartment.ARDECHE,
      FrenchDepartment.CANTAL,
      FrenchDepartment.DROME,
      FrenchDepartment.ISERE,
      FrenchDepartment.LOIRE,
      FrenchDepartment.HAUTE_LOIRE,
      FrenchDepartment.PUY_DE_DOME,
      FrenchDepartment.RHONE,
      FrenchDepartment.SAVOIE,
      FrenchDepartment.HAUTE_SAVOIE,
    ],
  },
  {
    code: FrenchRegion.BOURGOGNE_FRANCHE_COMTE,
    name: 'Bourgogne-Franche-Comté',
    departments: [
      FrenchDepartment.COTE_D_OR,
      FrenchDepartment.DOUBS,
      FrenchDepartment.JURA,
      FrenchDepartment.NIEVRE,
      FrenchDepartment.HAUTE_SAONE,
      FrenchDepartment.SAONE_ET_LOIRE,
      FrenchDepartment.YONNE,
      FrenchDepartment.TERRITOIRE_DE_BELFORT,
    ],
  },
  {
    code: FrenchRegion.BRETAGNE,
    name: 'Bretagne',
    departments: [
      FrenchDepartment.COTES_D_ARMOR,
      FrenchDepartment.FINISTERE,
      FrenchDepartment.ILLE_ET_VILAINE,
      FrenchDepartment.MORBIHAN,
    ],
  },
  {
    code: FrenchRegion.CENTRE_VAL_DE_LOIRE,
    name: 'Centre-Val de Loire',
    departments: [
      FrenchDepartment.CHER,
      FrenchDepartment.EURE_ET_LOIR,
      FrenchDepartment.INDRE,
      FrenchDepartment.INDRE_ET_LOIRE,
      FrenchDepartment.LOIR_ET_CHER,
      FrenchDepartment.LOIRET,
    ],
  },
  {
    code: FrenchRegion.CORSE,
    name: 'Corse',
    departments: [FrenchDepartment.CORSE_DU_SUD, FrenchDepartment.HAUTE_CORSE],
  },
  {
    code: FrenchRegion.GRAND_EST,
    name: 'Grand Est',
    departments: [
      FrenchDepartment.ARDENNES,
      FrenchDepartment.AUBE,
      FrenchDepartment.MARNE,
      FrenchDepartment.HAUTE_MARNE,
      FrenchDepartment.MEURTHE_ET_MOSELLE,
      FrenchDepartment.MEUSE,
      FrenchDepartment.MOSELLE,
      FrenchDepartment.BAS_RHIN,
      FrenchDepartment.HAUT_RHIN,
      FrenchDepartment.VOSGES,
    ],
  },
  {
    code: FrenchRegion.HAUTS_DE_FRANCE,
    name: 'Hauts-de-France',
    departments: [
      FrenchDepartment.AISNE,
      FrenchDepartment.NORD,
      FrenchDepartment.OISE,
      FrenchDepartment.PAS_DE_CALAIS,
      FrenchDepartment.SOMME,
    ],
  },
  {
    code: FrenchRegion.ILE_DE_FRANCE,
    name: 'Île-de-France',
    departments: [
      FrenchDepartment.PARIS,
      FrenchDepartment.SEINE_ET_MARNE,
      FrenchDepartment.YVELINES,
      FrenchDepartment.ESSONNE,
      FrenchDepartment.HAUTS_DE_SEINE,
      FrenchDepartment.SEINE_SAINT_DENIS,
      FrenchDepartment.VAL_DE_MARNE,
      FrenchDepartment.VAL_D_OISE,
    ],
  },
  {
    code: FrenchRegion.NORMANDIE,
    name: 'Normandie',
    departments: [
      FrenchDepartment.CALVADOS,
      FrenchDepartment.EURE,
      FrenchDepartment.MANCHE,
      FrenchDepartment.ORNE,
      FrenchDepartment.SEINE_MARITIME,
    ],
  },
  {
    code: FrenchRegion.NOUVELLE_AQUITAINE,
    name: 'Nouvelle-Aquitaine',
    departments: [
      FrenchDepartment.CHARENTE,
      FrenchDepartment.CHARENTE_MARITIME,
      FrenchDepartment.CORREZE,
      FrenchDepartment.CREUSE,
      FrenchDepartment.DORDOGNE,
      FrenchDepartment.GIRONDE,
      FrenchDepartment.LANDES,
      FrenchDepartment.LOT_ET_GARONNE,
      FrenchDepartment.PYRENEES_ATLANTIQUES,
      FrenchDepartment.DEUX_SEVRES,
      FrenchDepartment.VIENNE,
      FrenchDepartment.HAUTE_VIENNE,
    ],
  },
  {
    code: FrenchRegion.OCCITANIE,
    name: 'Occitanie',
    departments: [
      FrenchDepartment.ARIEGE,
      FrenchDepartment.AUDE,
      FrenchDepartment.AVEYRON,
      FrenchDepartment.GARD,
      FrenchDepartment.HAUTE_GARONNE,
      FrenchDepartment.GERS,
      FrenchDepartment.HERAULT,
      FrenchDepartment.LOT,
      FrenchDepartment.LOZERE,
      FrenchDepartment.HAUTES_PYRENEES,
      FrenchDepartment.PYRENEES_ORIENTALES,
      FrenchDepartment.TARN,
      FrenchDepartment.TARN_ET_GARONNE,
    ],
  },
  {
    code: FrenchRegion.PAYS_DE_LA_LOIRE,
    name: 'Pays de la Loire',
    departments: [
      FrenchDepartment.LOIRE_ATLANTIQUE,
      FrenchDepartment.MAINE_ET_LOIRE,
      FrenchDepartment.MAYENNE,
      FrenchDepartment.SARTHE,
      FrenchDepartment.VENDEE,
    ],
  },
  {
    code: FrenchRegion.PROVENCE_ALPES_COTE_D_AZUR,
    name: "Provence-Alpes-Côte d'Azur",
    departments: [
      FrenchDepartment.ALPES_DE_HAUTE_PROVENCE,
      FrenchDepartment.HAUTES_ALPES,
      FrenchDepartment.ALPES_MARITIMES,
      FrenchDepartment.BOUCHES_DU_RHONE,
      FrenchDepartment.VAR,
      FrenchDepartment.VAUCLUSE,
    ],
  },
  {
    code: FrenchRegion.GUADELOUPE,
    name: 'Guadeloupe',
    departments: [FrenchDepartment.GUADELOUPE],
  },
  {
    code: FrenchRegion.MARTINIQUE,
    name: 'Martinique',
    departments: [FrenchDepartment.MARTINIQUE],
  },
  {
    code: FrenchRegion.GUYANE,
    name: 'Guyane',
    departments: [FrenchDepartment.GUYANE],
  },
  {
    code: FrenchRegion.LA_REUNION,
    name: 'La Réunion',
    departments: [FrenchDepartment.LA_REUNION],
  },
  {
    code: FrenchRegion.MAYOTTE,
    name: 'Mayotte',
    departments: [FrenchDepartment.MAYOTTE],
  },
];

export const FRENCH_DEPARTMENTS_MAP: Record<
  FrenchDepartment,
  { code: string; name: string; region: FrenchRegion }
> = {
  [FrenchDepartment.AIN]: { code: '01', name: 'Ain', region: FrenchRegion.AUVERGNE_RHONE_ALPES },
  [FrenchDepartment.AISNE]: { code: '02', name: 'Aisne', region: FrenchRegion.HAUTS_DE_FRANCE },
  [FrenchDepartment.ALLIER]: { code: '03', name: 'Allier', region: FrenchRegion.AUVERGNE_RHONE_ALPES },
  [FrenchDepartment.ALPES_DE_HAUTE_PROVENCE]: {
    code: '04',
    name: 'Alpes-de-Haute-Provence',
    region: FrenchRegion.PROVENCE_ALPES_COTE_D_AZUR,
  },
  [FrenchDepartment.HAUTES_ALPES]: {
    code: '05',
    name: 'Hautes-Alpes',
    region: FrenchRegion.PROVENCE_ALPES_COTE_D_AZUR,
  },
  [FrenchDepartment.ALPES_MARITIMES]: {
    code: '06',
    name: 'Alpes-Maritimes',
    region: FrenchRegion.PROVENCE_ALPES_COTE_D_AZUR,
  },
  [FrenchDepartment.ARDECHE]: { code: '07', name: 'Ardèche', region: FrenchRegion.AUVERGNE_RHONE_ALPES },
  [FrenchDepartment.ARDENNES]: { code: '08', name: 'Ardennes', region: FrenchRegion.GRAND_EST },
  [FrenchDepartment.ARIEGE]: { code: '09', name: 'Ariège', region: FrenchRegion.OCCITANIE },
  [FrenchDepartment.AUBE]: { code: '10', name: 'Aube', region: FrenchRegion.GRAND_EST },
  [FrenchDepartment.AUDE]: { code: '11', name: 'Aude', region: FrenchRegion.OCCITANIE },
  [FrenchDepartment.AVEYRON]: { code: '12', name: 'Aveyron', region: FrenchRegion.OCCITANIE },
  [FrenchDepartment.BOUCHES_DU_RHONE]: {
    code: '13',
    name: 'Bouches-du-Rhône',
    region: FrenchRegion.PROVENCE_ALPES_COTE_D_AZUR,
  },
  [FrenchDepartment.CALVADOS]: { code: '14', name: 'Calvados', region: FrenchRegion.NORMANDIE },
  [FrenchDepartment.CANTAL]: { code: '15', name: 'Cantal', region: FrenchRegion.AUVERGNE_RHONE_ALPES },
  [FrenchDepartment.CHARENTE]: { code: '16', name: 'Charente', region: FrenchRegion.NOUVELLE_AQUITAINE },
  [FrenchDepartment.CHARENTE_MARITIME]: {
    code: '17',
    name: 'Charente-Maritime',
    region: FrenchRegion.NOUVELLE_AQUITAINE,
  },
  [FrenchDepartment.CHER]: { code: '18', name: 'Cher', region: FrenchRegion.CENTRE_VAL_DE_LOIRE },
  [FrenchDepartment.CORREZE]: { code: '19', name: 'Corrèze', region: FrenchRegion.NOUVELLE_AQUITAINE },
  [FrenchDepartment.CORSE_DU_SUD]: { code: '2A', name: 'Corse-du-Sud', region: FrenchRegion.CORSE },
  [FrenchDepartment.HAUTE_CORSE]: { code: '2B', name: 'Haute-Corse', region: FrenchRegion.CORSE },
  [FrenchDepartment.COTE_D_OR]: {
    code: '21',
    name: "Côte-d'Or",
    region: FrenchRegion.BOURGOGNE_FRANCHE_COMTE,
  },
  [FrenchDepartment.COTES_D_ARMOR]: { code: '22', name: "Côtes-d'Armor", region: FrenchRegion.BRETAGNE },
  [FrenchDepartment.CREUSE]: { code: '23', name: 'Creuse', region: FrenchRegion.NOUVELLE_AQUITAINE },
  [FrenchDepartment.DORDOGNE]: { code: '24', name: 'Dordogne', region: FrenchRegion.NOUVELLE_AQUITAINE },
  [FrenchDepartment.DOUBS]: { code: '25', name: 'Doubs', region: FrenchRegion.BOURGOGNE_FRANCHE_COMTE },
  [FrenchDepartment.DROME]: { code: '26', name: 'Drôme', region: FrenchRegion.AUVERGNE_RHONE_ALPES },
  [FrenchDepartment.EURE]: { code: '27', name: 'Eure', region: FrenchRegion.NORMANDIE },
  [FrenchDepartment.EURE_ET_LOIR]: {
    code: '28',
    name: 'Eure-et-Loir',
    region: FrenchRegion.CENTRE_VAL_DE_LOIRE,
  },
  [FrenchDepartment.FINISTERE]: { code: '29', name: 'Finistère', region: FrenchRegion.BRETAGNE },
  [FrenchDepartment.GARD]: { code: '30', name: 'Gard', region: FrenchRegion.OCCITANIE },
  [FrenchDepartment.HAUTE_GARONNE]: { code: '31', name: 'Haute-Garonne', region: FrenchRegion.OCCITANIE },
  [FrenchDepartment.GERS]: { code: '32', name: 'Gers', region: FrenchRegion.OCCITANIE },
  [FrenchDepartment.GIRONDE]: { code: '33', name: 'Gironde', region: FrenchRegion.NOUVELLE_AQUITAINE },
  [FrenchDepartment.HERAULT]: { code: '34', name: 'Hérault', region: FrenchRegion.OCCITANIE },
  [FrenchDepartment.ILLE_ET_VILAINE]: { code: '35', name: 'Ille-et-Vilaine', region: FrenchRegion.BRETAGNE },
  [FrenchDepartment.INDRE]: { code: '36', name: 'Indre', region: FrenchRegion.CENTRE_VAL_DE_LOIRE },
  [FrenchDepartment.INDRE_ET_LOIRE]: {
    code: '37',
    name: 'Indre-et-Loire',
    region: FrenchRegion.CENTRE_VAL_DE_LOIRE,
  },
  [FrenchDepartment.ISERE]: { code: '38', name: 'Isère', region: FrenchRegion.AUVERGNE_RHONE_ALPES },
  [FrenchDepartment.JURA]: { code: '39', name: 'Jura', region: FrenchRegion.BOURGOGNE_FRANCHE_COMTE },
  [FrenchDepartment.LANDES]: { code: '40', name: 'Landes', region: FrenchRegion.NOUVELLE_AQUITAINE },
  [FrenchDepartment.LOIR_ET_CHER]: {
    code: '41',
    name: 'Loir-et-Cher',
    region: FrenchRegion.CENTRE_VAL_DE_LOIRE,
  },
  [FrenchDepartment.LOIRE]: { code: '42', name: 'Loire', region: FrenchRegion.AUVERGNE_RHONE_ALPES },
  [FrenchDepartment.HAUTE_LOIRE]: {
    code: '43',
    name: 'Haute-Loire',
    region: FrenchRegion.AUVERGNE_RHONE_ALPES,
  },
  [FrenchDepartment.LOIRE_ATLANTIQUE]: {
    code: '44',
    name: 'Loire-Atlantique',
    region: FrenchRegion.PAYS_DE_LA_LOIRE,
  },
  [FrenchDepartment.LOIRET]: { code: '45', name: 'Loiret', region: FrenchRegion.CENTRE_VAL_DE_LOIRE },
  [FrenchDepartment.LOT]: { code: '46', name: 'Lot', region: FrenchRegion.OCCITANIE },
  [FrenchDepartment.LOT_ET_GARONNE]: {
    code: '47',
    name: 'Lot-et-Garonne',
    region: FrenchRegion.NOUVELLE_AQUITAINE,
  },
  [FrenchDepartment.LOZERE]: { code: '48', name: 'Lozère', region: FrenchRegion.OCCITANIE },
  [FrenchDepartment.MAINE_ET_LOIRE]: {
    code: '49',
    name: 'Maine-et-Loire',
    region: FrenchRegion.PAYS_DE_LA_LOIRE,
  },
  [FrenchDepartment.MANCHE]: { code: '50', name: 'Manche', region: FrenchRegion.NORMANDIE },
  [FrenchDepartment.MARNE]: { code: '51', name: 'Marne', region: FrenchRegion.GRAND_EST },
  [FrenchDepartment.HAUTE_MARNE]: { code: '52', name: 'Haute-Marne', region: FrenchRegion.GRAND_EST },
  [FrenchDepartment.MAYENNE]: { code: '53', name: 'Mayenne', region: FrenchRegion.PAYS_DE_LA_LOIRE },
  [FrenchDepartment.MEURTHE_ET_MOSELLE]: {
    code: '54',
    name: 'Meurthe-et-Moselle',
    region: FrenchRegion.GRAND_EST,
  },
  [FrenchDepartment.MEUSE]: { code: '55', name: 'Meuse', region: FrenchRegion.GRAND_EST },
  [FrenchDepartment.MORBIHAN]: { code: '56', name: 'Morbihan', region: FrenchRegion.BRETAGNE },
  [FrenchDepartment.MOSELLE]: { code: '57', name: 'Moselle', region: FrenchRegion.GRAND_EST },
  [FrenchDepartment.NIEVRE]: { code: '58', name: 'Nièvre', region: FrenchRegion.BOURGOGNE_FRANCHE_COMTE },
  [FrenchDepartment.NORD]: { code: '59', name: 'Nord', region: FrenchRegion.HAUTS_DE_FRANCE },
  [FrenchDepartment.OISE]: { code: '60', name: 'Oise', region: FrenchRegion.HAUTS_DE_FRANCE },
  [FrenchDepartment.ORNE]: { code: '61', name: 'Orne', region: FrenchRegion.NORMANDIE },
  [FrenchDepartment.PAS_DE_CALAIS]: {
    code: '62',
    name: 'Pas-de-Calais',
    region: FrenchRegion.HAUTS_DE_FRANCE,
  },
  [FrenchDepartment.PUY_DE_DOME]: {
    code: '63',
    name: 'Puy-de-Dôme',
    region: FrenchRegion.AUVERGNE_RHONE_ALPES,
  },
  [FrenchDepartment.PYRENEES_ATLANTIQUES]: {
    code: '64',
    name: 'Pyrénées-Atlantiques',
    region: FrenchRegion.NOUVELLE_AQUITAINE,
  },
  [FrenchDepartment.HAUTES_PYRENEES]: { code: '65', name: 'Hautes-Pyrénées', region: FrenchRegion.OCCITANIE },
  [FrenchDepartment.PYRENEES_ORIENTALES]: {
    code: '66',
    name: 'Pyrénées-Orientales',
    region: FrenchRegion.OCCITANIE,
  },
  [FrenchDepartment.BAS_RHIN]: { code: '67', name: 'Bas-Rhin', region: FrenchRegion.GRAND_EST },
  [FrenchDepartment.HAUT_RHIN]: { code: '68', name: 'Haut-Rhin', region: FrenchRegion.GRAND_EST },
  [FrenchDepartment.RHONE]: { code: '69', name: 'Rhône', region: FrenchRegion.AUVERGNE_RHONE_ALPES },
  [FrenchDepartment.HAUTE_SAONE]: {
    code: '70',
    name: 'Haute-Saône',
    region: FrenchRegion.BOURGOGNE_FRANCHE_COMTE,
  },
  [FrenchDepartment.SAONE_ET_LOIRE]: {
    code: '71',
    name: 'Saône-et-Loire',
    region: FrenchRegion.BOURGOGNE_FRANCHE_COMTE,
  },
  [FrenchDepartment.SARTHE]: { code: '72', name: 'Sarthe', region: FrenchRegion.PAYS_DE_LA_LOIRE },
  [FrenchDepartment.SAVOIE]: { code: '73', name: 'Savoie', region: FrenchRegion.AUVERGNE_RHONE_ALPES },
  [FrenchDepartment.HAUTE_SAVOIE]: {
    code: '74',
    name: 'Haute-Savoie',
    region: FrenchRegion.AUVERGNE_RHONE_ALPES,
  },
  [FrenchDepartment.PARIS]: { code: '75', name: 'Paris', region: FrenchRegion.ILE_DE_FRANCE },
  [FrenchDepartment.SEINE_MARITIME]: { code: '76', name: 'Seine-Maritime', region: FrenchRegion.NORMANDIE },
  [FrenchDepartment.SEINE_ET_MARNE]: {
    code: '77',
    name: 'Seine-et-Marne',
    region: FrenchRegion.ILE_DE_FRANCE,
  },
  [FrenchDepartment.YVELINES]: { code: '78', name: 'Yvelines', region: FrenchRegion.ILE_DE_FRANCE },
  [FrenchDepartment.DEUX_SEVRES]: {
    code: '79',
    name: 'Deux-Sèvres',
    region: FrenchRegion.NOUVELLE_AQUITAINE,
  },
  [FrenchDepartment.SOMME]: { code: '80', name: 'Somme', region: FrenchRegion.HAUTS_DE_FRANCE },
  [FrenchDepartment.TARN]: { code: '81', name: 'Tarn', region: FrenchRegion.OCCITANIE },
  [FrenchDepartment.TARN_ET_GARONNE]: { code: '82', name: 'Tarn-et-Garonne', region: FrenchRegion.OCCITANIE },
  [FrenchDepartment.VAR]: { code: '83', name: 'Var', region: FrenchRegion.PROVENCE_ALPES_COTE_D_AZUR },
  [FrenchDepartment.VAUCLUSE]: {
    code: '84',
    name: 'Vaucluse',
    region: FrenchRegion.PROVENCE_ALPES_COTE_D_AZUR,
  },
  [FrenchDepartment.VENDEE]: { code: '85', name: 'Vendée', region: FrenchRegion.PAYS_DE_LA_LOIRE },
  [FrenchDepartment.VIENNE]: { code: '86', name: 'Vienne', region: FrenchRegion.NOUVELLE_AQUITAINE },
  [FrenchDepartment.HAUTE_VIENNE]: {
    code: '87',
    name: 'Haute-Vienne',
    region: FrenchRegion.NOUVELLE_AQUITAINE,
  },
  [FrenchDepartment.VOSGES]: { code: '88', name: 'Vosges', region: FrenchRegion.GRAND_EST },
  [FrenchDepartment.YONNE]: { code: '89', name: 'Yonne', region: FrenchRegion.BOURGOGNE_FRANCHE_COMTE },
  [FrenchDepartment.TERRITOIRE_DE_BELFORT]: {
    code: '90',
    name: 'Territoire de Belfort',
    region: FrenchRegion.BOURGOGNE_FRANCHE_COMTE,
  },
  [FrenchDepartment.ESSONNE]: { code: '91', name: 'Essonne', region: FrenchRegion.ILE_DE_FRANCE },
  [FrenchDepartment.HAUTS_DE_SEINE]: {
    code: '92',
    name: 'Hauts-de-Seine',
    region: FrenchRegion.ILE_DE_FRANCE,
  },
  [FrenchDepartment.SEINE_SAINT_DENIS]: {
    code: '93',
    name: 'Seine-Saint-Denis',
    region: FrenchRegion.ILE_DE_FRANCE,
  },
  [FrenchDepartment.VAL_DE_MARNE]: { code: '94', name: 'Val-de-Marne', region: FrenchRegion.ILE_DE_FRANCE },
  [FrenchDepartment.VAL_D_OISE]: { code: '95', name: "Val-d'Oise", region: FrenchRegion.ILE_DE_FRANCE },
  [FrenchDepartment.GUADELOUPE]: { code: '971', name: 'Guadeloupe', region: FrenchRegion.GUADELOUPE },
  [FrenchDepartment.MARTINIQUE]: { code: '972', name: 'Martinique', region: FrenchRegion.MARTINIQUE },
  [FrenchDepartment.GUYANE]: { code: '973', name: 'Guyane', region: FrenchRegion.GUYANE },
  [FrenchDepartment.LA_REUNION]: { code: '974', name: 'La Réunion', region: FrenchRegion.LA_REUNION },
  [FrenchDepartment.MAYOTTE]: { code: '976', name: 'Mayotte', region: FrenchRegion.MAYOTTE },
};

export function getDepartmentLabel(dept: FrenchDepartment): string {
  const info = FRENCH_DEPARTMENTS_MAP[dept];
  return info ? `${info.name} (${info.code})` : `${dept}`;
}
